// Styles for OffersBrandRibbon go here.
import styled from 'styled-components';

export const StyledOffersBrandRibbon = styled.div``;
export const StyledOffersBrandRibbonPreviewMode = styled.div`
  pointer-events: none;
`;
